// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"c29187bb","754":"617e541f"}[chunkId] + ".chunk.js";
};